import { useDashboardData } from "./hooks/useDashboardData";
import { getStatsConfig, QUICK_ACTIONS_CONFIG } from "./constants/dashboardConstants";
import WhatsAppConnect from "../../components/whatsapp/dashboard/Connect";
import { DashboardHeader } from "./components/DashboardHeader";
import { PhoneNumberSelector } from "./components/PhoneNumberSelector";
import { PaidFeaturesBanner } from "./components/PaidFeaturesBanner";
import { WABABanner } from "./components/WABABanner";
import { StatsGrid } from "./components/StatsGrid";
import { QuickActionsGrid } from "./components/QuickActionsGrid";
import { useSelector } from 'react-redux';
import { hasActivePlan } from '../../utils/capabilitiesHelper';
import { usePageTitle } from '../../hooks/usePageTitle';
import { whatsappPageShell, waShell } from "./utils/whatsappPageShell";
import { DashboardSkeleton } from "./components/skeletons/WhatsAppPageSkeletons";

export default function WhatsAppDashboard() {
    usePageTitle('WhatsApp Dashboard');

    const {
        isConnected,
        phones,
        selectedNumber,
        showConnect,
        currentNumber,
        setSelectedNumber,
        setShowConnect,
        totalSent,
        totalDelivered,
        deliveryRate,
        wabaLoading,
    } = useDashboardData();

    const capabilities = useSelector((state) => state.capabilities.capabilities);
    const capabilitiesLoading = useSelector((state) => state.capabilities.loading);
    const hasActivePlanValue = hasActivePlan(capabilities);

    const isLoading = wabaLoading || capabilitiesLoading;

    if (showConnect) {
        return <WhatsAppConnect onClose={() => setShowConnect(false)} />;
    }

    if (isLoading) {
        return <DashboardSkeleton />;
    }

    const statsConfig = getStatsConfig(totalSent, totalDelivered, isConnected, deliveryRate);

    const quickActionsConfig = QUICK_ACTIONS_CONFIG(isConnected);

    return (
        <div className={waShell(whatsappPageShell.fluid, "animate-fade-in")}>
            <DashboardHeader
                isConnected={isConnected}
                onConnectClick={() => setShowConnect(true)}
            />

            {isConnected && (
                <PhoneNumberSelector
                    phones={phones}
                    selectedNumber={selectedNumber}
                    onSelectionChange={setSelectedNumber}
                    currentNumber={currentNumber}
                />
            )}

            <PaidFeaturesBanner isPaid={hasActivePlanValue} />

            <WABABanner isConnected={isConnected} currentNumber={currentNumber} />

            <StatsGrid stats={statsConfig} />

            <QuickActionsGrid actions={quickActionsConfig} />
        </div>
    );
}
